const mngrMbrMngt = {
    namespaced: true,
    state : {
        mngrMbrId : ''
    },
    getters: {
        getMngrMbrId (state) {
            return state.mngrMbrId
        },
    },
    mutations: {
        setMngrMbrId (state, payload) {
            state.mngrMbrId = payload
        }
    },
    actions: {
        setMngrMbrId ({commit}, payload) {
            commit('setMngrMbrId', payload)
        }
    }
}


export default mngrMbrMngt